import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-rejected-approved-dialog',
  templateUrl: './rejected-approved-dialog.component.html',
  styleUrls: ['./rejected-approved-dialog.component.css'],
})
export class RejectedApprovedDialogComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}
  close() {
    this.dialog.closeAll();
  }
}
